import React, { useState, useMemo, useEffect } from 'react';
import { Typography, Card, Grid } from "@mui/material";
import Box from '@mui/material/Box';
import { useSelector } from "react-redux";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import DataGridComponent from '../../common/DataGridComponent/DataGridComponent';
import Spinner2 from "../../common/Spinner/Spinner2";
import commonApiService from '../../../../shared/common-utilities/services/commonApiService.jsx';
import _ from 'lodash';
import { getShipmentMov, fetchSavedView, getPartialTrip  } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import ModalComponent from '../../common/Modal/ModalComponent';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService.jsx';

const entity = "ptmovement";
const odataApiName = "ptmovements";
const odataApiNameFor = "ptmovements"; // Future use if need to open as popup from any plan function
let service = getSetDataService();
let apiService = commonApiService();
let storageService = dataStorageService();
let dataRelatedAction = ['Filter', 'View Columns', 'Settings', 'Refresh', 'New Window'];
const planRelatedAction = ['Set Free'];

const ShipmentMovements = (prop) => {

  const smovGriddDtaItemKey = "id";

  //#region Reference
  const smovGrid = React.useRef(null);
  //#endregion Reference

  //#region Hook Selctor
  const partialTripReducerData = useSelector(state => state.partialTrip);
  let gridSelectedValues = {};
  //#endregion Hook Selctor

  //#region States - Get set variables  
  const initialSort = service.initialSort[entity];
  const shipmentMovementGridRefreshReducerData = useSelector(state => state?.shipmentMovements?.isRefreshShipmentMovementGridData);
  const [smovGridColumnList, setSmovGridColumnList] = React.useState(null);
  const [tempSmovGridColumnList, setTempSmovGridColumnList] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);

  const [tempShipmentMovementsData, setTempShipmentMovementsData] = useState([]);

  const [loadedGridData, setLoadedGridData] = useState(tempShipmentMovementsData);
  const [myGridData, setmyGridData] = React.useState([]);
  const [loadSelectionValue, setloadSelectionValue] = useState(100);
  const [totalData, setTotalData] = useState();
  const userID = localStorage.getItem('userID');

  const [isShipmentMovements, setIsShipmentMovements] = useState(true);
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  let [initialFilter, setInitialFilter] = useState([]);
  const [nextDataUrl, setNextDataUrl] = useState(null);
  const [initialSaveViewData, setInitialSaveViewData] = useState([]);
  const [initialFetchReadLinkData, setInitialFetchReadLinkData] = useState(null);
  const [tripId, setTripId] = useState(null);
  const [changeToChildSM, setChangeToChildSM] = useState(null);
  const [isApiCallRequired, setIsApiCallRequired] = useState(true);
  const [openConfirmationModal, setopenConfirmationModal] = useState(false);
  const [commonPopupParameters, setCommonPopupParameters] = React.useState({});
  const [errorMessage, setErrorMessage] = useState(null);
  const [canExecute, setCanExecute] = useState([]);
  const [isMultipleData,setIsMultipleData] = useState(false)
  const smovFilterComponents = [];
  const metaData = JSON.parse(storageService.getLocalStorageData("metaData"))

  //#endregion States


  //#region Hooks  

  useEffect(() => {
    // setIsLoading(true);

    setIsApiLoaded(true);
    setTimeout(()=>{
      setGridColumns(entity);
    },100)
    let tempFilterData = [];
    setInitialFilter(tempFilterData);

    dataRelatedAction = prop?.isChild ? dataRelatedAction.filter(e => e != 'Filter') : dataRelatedAction;
  }, []);

  useEffect(() => {
    if (tripId != null && !_.isNil(paramsData) && (prop.guid == partialTripReducerData.guid)) {
      sendApiForSmov();
    }
  }, [tripId,partialTripReducerData.isRefreshRouteAndPT]);
  useEffect(()=>{
    if(!_.isNil(partialTripReducerData)  && (prop.guid == partialTripReducerData.guid)) {
      setIsMultipleData(partialTripReducerData.isMultiplePT)
    }
  },[partialTripReducerData.isMultiplePT])
  useEffect(() => {
    if (!_.isNil(partialTripReducerData) && (prop.guid == partialTripReducerData.guid)) {
      setTripId(partialTripReducerData.tripNumber);
    }
  }, [partialTripReducerData])

  useEffect(() => {
    if (shipmentMovementGridRefreshReducerData?.isRefreshShipmentMovementGridData) {
      setNextDataUrl(null);
      setParamsData({ ...paramsData });
    }
  }, [shipmentMovementGridRefreshReducerData])

  const setGridColumns = (entityName) => {
    const columnList = localStorage.getItem(entityName + 'ColumnList');
    if (!_.isNil(columnList)) {
      setSmovGridColumnList(JSON.parse(columnList));
      getColList(entity, JSON.parse(columnList));
      return true;
    }

    if(!_.isNil(metaData) || metaData !== "undefined") {
      service.entityDefinitions(metaData,entityName).then((tempFieldList)=>{
        tempFieldList.unshift({
          field: 'ActionColumn',
          title: 'Action',
          visible: true,
          width: 80,
          locked: false,
          order: 'asc',
          groupBy: false
        })

        localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList));
        setSmovGridColumnList(tempFieldList);
        getColList(entity, tempFieldList);
      })
    }
  }

  const getDefaultColList = (dcolsString, entityName, gridcolumns) => {
    const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"));
    if (!_.isNil(dcolsString) && dcolsString != "undefined") {
      const defaultColumnList = gridcolumns?.filter(item => {
        return dCols[entity]?.split("~").includes(item.field) || item.field == 'instructionsExist' || item.field == 'qualificationsExist' || item.field == 'ActionColumn';
      });
      if (defaultColumnList.length == 0) {
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
        setTempSmovGridColumnList(gridcolumns);
      } else {
        const sortedArr = _.sortBy(defaultColumnList, function (item) { return dCols[entity]?.split("~").indexOf(item.field) });
        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(sortedArr))
        setTempSmovGridColumnList(sortedArr);

        const arr1 = sortedArr;
        const arr2 = gridcolumns.filter(e => !sortedArr.map(x => x.field).includes(e.field));
        const newsortedArr = _.concat(arr1, arr2);
        setSmovGridColumnList(newsortedArr);
      }
    } else {
      localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(gridcolumns));
      setTempSmovGridColumnList(gridcolumns);
    }
  }

  const getColList = (entityName,gridcolumns) => {
    const smUrl = `${fetchSavedView}?$filter=(title eq '${odataApiName}' and userID eq '${userID}')`;
    const dcolsStringSM = localStorage.getItem("defaultColumnSetting");
    apiService.get(smUrl).then(savedViewRes => {
      if (savedViewRes?.value?.length > 0) {
        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"],null,null,null,null, savedViewRes.value[0]["@odata.etag"]).then(readResSM => {
          if (readResSM !== undefined && readResSM !== null) {
            setInitialSaveViewData(savedViewRes.value);
            setInitialFetchReadLinkData(readResSM);
            const defaultViewExist = readResSM[odataApiName]?.savedViews?.filter(item => item.defaultView);
            if (defaultViewExist?.length > 0 && defaultViewExist[0] !== undefined && defaultViewExist?.[0]?.columns) {
              setCanExecute(defaultViewExist);
              setTempSmovGridColumnList(defaultViewExist[0].columns);
            } else if (readResSM[odataApiName]?.columns?.length !== 0) {
              localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readResSM[odataApiName]?.columns));
              setTempSmovGridColumnList(readResSM[odataApiName]?.columns);
            } else {
              getDefaultColList(dcolsStringSM, entityName, gridcolumns);
            }
          }
        })
      } else {
        getDefaultColList(dcolsStringSM, entityName, gridcolumns);
      }

      setIsLoading(false);
    });
  }

  useEffect((e) => {
    if (!_.isNil(paramsData) && isApiCallRequired) {
      if (prop.isChild) {
        sendApiForSmov();
      } else {
        updateSendApi(loadSelectionValue);
      }
    } else {
      setIsApiCallRequired(true);
    }
  }, [paramsData]);

  useEffect(() => {
    if (prop.isPin !== undefined && prop.isPin !== null) {
      setIsShipmentMovements(prop.isPin);
    }
  }, [prop.isPin])

  useEffect((e) => {
    if (!_.isNil(tempSmovGridColumnList)) {
      if (prop.isChild) {
        sendApiForSmov();
      } else {
        setNextDataUrl(null);
        setIsApiCallRequired(true);
      }
    }
  }, [tempSmovGridColumnList]);

  //#endregion Hooks

  // --- API's Call START ---


  const sendApi = (val, size) => {
    let filter = paramsData?.filter ? '$filter=(' + paramsData?.filter + ')' : null;
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    if (canExecute?.length > 0) {
      return;
    }
    if (tempSmovGridColumnList !== null && tempSmovGridColumnList !== undefined && tempSmovGridColumnList.length > 0 && !prop.isChild && !prop?.customView) {
      setIsLoading(true);
      const params = '&' + filter + '&' + orderby + '&$count=true';
      const columns = tempSmovGridColumnList.filter(item => item.field != 'ActionColumn').map(item => item.field);
      const mandatroyEntity = JSON.parse(localStorage.mandatoryColumnList).find(e => e.entity == odataApiName);
      if (!_.isNull(mandatroyEntity)) {
        let splitedColums = mandatroyEntity.mandatoryColumns.split("~");
        splitedColums.forEach(element => {
          if (!columns.includes(element)) {
            columns.push(element)
          }
        });
      }
      const selectFields = `&$select=${columns}`;
      const oDataNextLink = val == 'Scroll' ? nextDataUrl : null;
      apiService.get(getShipmentMov,params, `${selectFields}`, oDataNextLink, size,null).then(response => {
        if (response !== null && response !== undefined && response.error !== null && response.error !== undefined && response.error) {
          setErrorParameterAndMessage(response?.error?.message.split('CorrelationId')[0]);
          if (response?.error?.message?.includes('$orderby')) {
            const sortToRemoveSM = response.error.message.split("'")[1];
            setChangeToChildSM({ type: "sort", value: sortToRemoveSM });
          } else if (response?.error?.code == "Application_FilterErrorException") {
            const filterToRemoveSM = response.error.message.split("'")[1];
            setChangeToChildSM({ type: "filter", value: filterToRemoveSM });
          }
        } else {
          if (response.value) {
            setTotalData(response["@odata.count"]);
            let tempData = [];
            if (val == 'Scroll' && tempShipmentMovementsData !== null && tempShipmentMovementsData !== undefined && tempShipmentMovementsData.length > 0) {
              tempShipmentMovementsData.forEach(tempSmov => {
                tempData.push(tempSmov);
              });
              response.value.map(temp => {
                tempData.push(temp)
              })
            }
            // Update the data based on the response
            else {
              tempData = response.value;
            }
  
            const tempDate = service.setColorCodeAndDate(tempData,smovGridColumnList);
            if (response['@odata.nextLink'] !== null && response['@odata.nextLink'] !== undefined) {
              setNextDataUrl(response['@odata.nextLink']);
            }
  
            setTempShipmentMovementsData(tempDate);
            setmyGridData(tempDate);
            setLoadedGridData(tempDate);
            setIsApiLoaded(true);
          }
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }

  const updateSendApi = useMemo(() => {
    return _.debounce((size) => {
      sendApi(null, size);
    }, 250);
  }, [sendApi]);

  const sendApiForSmov = () => {
    if (_.isNil(tripId) || tripId == "") {
      setTotalData(0);
      setmyGridData([]);
      setLoadedGridData([]);
      setTempShipmentMovementsData([]);
      return;
    }
    let filter = "$filter=(id eq " + tripId + ")";
    let orderby = paramsData?.orderby ? '$orderby=' + paramsData?.orderby : null;
    const params = '&' + filter + '&$count=true';
    let expands = '&$expand=ptmovements';
    if (orderby !== null && orderby !== undefined) {
      expands += '(' + orderby + ')';
    }
    
    if (!prop?.customView) {
      setIsLoading(true);
      apiService.get(getPartialTrip,null, `${params}${expands}`,null,null,null).then(response => {
        if (response.value !== null && response.value !== undefined && response.value.length > 0) {
          setTotalData(response.value[0].ptmovements?.length);
          const tempData = service.setColorCodeAndDate(response.value[0].ptmovements,smovGridColumnList);
          setmyGridData(tempData);
          setLoadedGridData(tempData);
          setTempShipmentMovementsData(tempData);
        } else if (response.value !== null && response.value !== undefined && response.value.length === 0) {
          setTotalData(0);
          setmyGridData([]);
          setLoadedGridData([]);
          setTempShipmentMovementsData([]);
        } else {
          // Error Handling code here
          console.error("Response value is not available.");
        }
      })
        .catch(error => {
          console.error('API error:', error);
        })
        .finally(() => {
          setIsLoading(false);
        })
    }
  }

  // --- API's Call END ---

  const childStateHandler = (value, flag) => {
    if (flag === 'showGridHeader') {
      setIsShipmentMovements(value);
    } else if (flag === 'getData') {
      setNextDataUrl(null);
      setParamsData({ ...paramsData, filter: value.filter, orderby: value.orderby });
      setIsApiCallRequired(value.isApiCall);
      setTempSmovGridColumnList(value.columns);
      setCanExecute([]);
    } else if (flag === 'refresh') {
      if (prop.isChild) {
        sendApiForSmov();
      } else {
        sendApi(null, loadSelectionValue);
      }   
    } else if (flag === 'selectedValues') {
      gridSelectedValues = value;
    } else if (flag === 'sendApiForSmov') {
      if (prop.isChild) {
        sendApiForSmov();
      }
    } else if (flag === 'columnsVisible') {
      setTempSmovGridColumnList(value);
    }
  }

  // --- Common methods END ---

  //#endregion Methods

  //#region Not in use

  const onLoadSelectionChange = (e) => {
    if (prop.isChild) {
      sendApiForSmov();
    } else {
      let value = e.value;
      setloadSelectionValue(value);
      sendApi(null, value);
    }
  }

  const setErrorParameterAndMessage = (errMsg) => {
    setCommonPopupParameters({
      title: 'Error'
    });
    setErrorMessage(errMsg);
    setopenConfirmationModal(true);
  }

  const closeConfirmationModal = () => {
    setopenConfirmationModal(false);
  }

  const onGridClick = () => {
    if (window.location.hash.includes("#/CustomView")){
      storageService.setLocalStorageData('currentActive', odataApiName);
    }
  }

  //#endregion

  return (
    <>
      {isLoading ? (<Spinner2 isAll={loadSelectionValue} />) : (<></>)}
      <Grid item xs={12} square component={Card} elevation={0} sx={{ p: 1, width: '100%' }} onClick={onGridClick}>

        {isShipmentMovements && <Box className="headBG" sx={{ px: 1, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="body2" color="secondary.contrastText" sx={{ fontWeight: 500 }}>Shipment Movements</Typography>
        </Box>}
        <Box sx={{ p: 0, display: 'flex' }} className='filterbar-bg '>
          <Grid
            item={true}
            elevation={0}
            pl={0}
            sx={{ flexGrow: 1, }}
            className="grid-movement"
            xs component={Card}
          >
            {isApiLoaded && <DataGridComponent
              {...prop}
              gridRef={smovGrid}
              gridFlagVal={odataApiName}
              gridFlagValFor={odataApiNameFor}
              gridStyle={{ maxHeight: 'calc(100%)', height: '100%', minHeight: '650px' }}
              entity={entity}
              gridNewData={isMultipleData ? [] : myGridData}
              loadedGridData={isMultipleData ? [] : loadedGridData}
              tempGridData={isMultipleData ? [] : tempShipmentMovementsData}
              gridColumnList={smovGridColumnList ? smovGridColumnList : []}
              gridTempColumnList={tempSmovGridColumnList ? tempSmovGridColumnList : []}
              isItemVisible={false}
              gridSort={initialSort}
              gridInitialFilter={initialFilter}
              isShowGridHeader={isShipmentMovements}
              griddDtaItemKey={smovGriddDtaItemKey}
              sendDataToParent={childStateHandler}
              gridDataAction={dataRelatedAction}
              gridPlanAction={planRelatedAction}
              gridFilterComponents={smovFilterComponents}
              onLoadSelectionChange={onLoadSelectionChange}
              loadSelectionValue={loadSelectionValue}
              gridtotalData={isMultipleData ? 0 : totalData}
              initialSaveViewData={initialSaveViewData}
              initialFetchReadLinkData={initialFetchReadLinkData}
              changeToChild={changeToChildSM}
              isDraggable={true}
            />}
          </Grid>
        </Box>
        <ModalComponent message={errorMessage} params={commonPopupParameters} openConfirmationModal={openConfirmationModal} closeConfirmationModal={closeConfirmationModal} />
      </Grid>
    </>
  )
}

export default ShipmentMovements;